import React, { useEffect, useRef } from "react";
import { Popup } from "@progress/kendo-react-popup";
import { useActionRegistry } from "../../../../components/App/ActionRegistryContext";

/**
 * Popup menu for the header "Add Chip" main button: Global Chip vs Project Chip.
 * Arrow on the split button stays Kendo-only (Add Task / Add reminder).
 * @author Muskan Thakur
 */
const ChipTypeMainPopup = ({ show, onClose, anchorRef, splitButtonRootRef, menuItems, displayTeamChipName }) => {
  const { getAction } = useActionRegistry();
  const contentRef = useRef(null);

  useEffect(() => {
    if (!show) return;
    const onMouseDown = (e) => {
      const popupEl = contentRef.current;
      if (popupEl?.contains(e.target)) return;
      const root = splitButtonRootRef?.current;
      if (!root?.contains(e.target)) {
        onClose();
        return;
      }
      const onArrow = typeof e.target?.closest === "function" && e.target.closest(".k-split-button-arrow");
      if (onArrow) {
        onClose();
      }
    };
    document.addEventListener("mousedown", onMouseDown, true);
    return () => document.removeEventListener("mousedown", onMouseDown, true);
  }, [show, onClose, splitButtonRootRef]);

  if (!menuItems?.length) return null;

  const runAction = (itemId) => {
    const handler = getAction(itemId);
    if (handler) handler();
    onClose();
  };

  return (
    <Popup
      anchor={anchorRef?.current}
      show={show}
      animate={false}
      anchorAlign={{ vertical: "center", horizontal: "center" }}
      popupAlign={{ vertical: "top", horizontal: "right" }}
      popupClass='custom-split-popup chip-split-popup chip-type-main-popup'>
      <div ref={contentRef} className='k-menu-group k-reset' role='menu'>
        {menuItems.map((item) => {
          const itemText = typeof item.text === "function" ? item.text(displayTeamChipName) : item.text;
          return (
            <div
              key={item.id}
              className='k-item k-menu-item'
              role='menuitem'
              tabIndex={0}
              onClick={() => runAction(item.id)}
              onKeyDown={(ev) => {
                if (ev.key === "Enter" || ev.key === " ") {
                  ev.preventDefault();
                  runAction(item.id);
                }
              }}>
              <span className='k-link k-menu-link'>
                <span className='chip-option-label'>
                  {itemText}
                </span>
              </span>
            </div>
          );
        })}
      </div>
    </Popup>
  );
};

export default ChipTypeMainPopup;
